export default '/build/ac749d99.svg'